import React from "react";
import { motion } from "framer-motion";

// Editorial, high-brow logo wordmarks — real-feeling but original.
// Each is an SVG wordmark so we never show raw text as a "fake brand".
const BRANDS = [
  { name: "Lumen & Sons", style: "font-editorial italic font-light text-[26px]" },
  { name: "ATLAS/CO", style: "font-display font-black tracking-tighter text-[26px]" },
  { name: "NOIR studios", style: "font-display font-light tracking-[0.2em] uppercase text-[20px]" },
  { name: "Vellum", style: "font-editorial italic text-[30px]" },
  { name: "HALO", style: "font-display font-black tracking-widest text-[26px]" },
  { name: "Northgate", style: "font-display font-medium text-[24px]" },
  { name: "CINDER/", style: "font-mono font-medium tracking-tighter text-[22px]" },
  { name: "Obscura", style: "font-editorial italic font-semibold text-[28px]" },
  { name: "Reverie", style: "font-editorial italic font-light text-[28px]" },
  { name: "KITE labs", style: "font-display font-bold tracking-tighter text-[24px]" },
];

const LogosMarquee = () => {
  return (
    <section
      id="logos"
      data-testid="logos-marquee-container"
      className="relative py-24 border-y border-white/5 bg-[#060709] overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-20%" }}
        transition={{ duration: 1 }}
        className="max-w-[1280px] mx-auto px-6 sm:px-10 mb-14 flex items-end justify-between gap-6"
      >
        <div>
          <div className="mono-label mb-3">— Trusted by</div>
          <h3 className="font-display text-xl sm:text-2xl font-light tracking-tight text-[#F4F4F2] max-w-[32ch]">
            Studios, founders and galleries who refused to look like
            <span className="text-accent"> everyone else.</span>
          </h3>
        </div>
        <div className="hidden md:block font-mono text-[10px] uppercase tracking-[0.25em] text-[#5A5D68] text-right">
          084 sites<br />shipped since 2021
        </div>
      </motion.div>

      <div className="marquee">
        <div className="marquee-track">
          {[...BRANDS, ...BRANDS].map((b, i) => (
            <div
              key={i}
              className={`shrink-0 text-[#6B6E78] hover:text-[#F4F4F2] transition-colors duration-500 ${b.style}`}
              style={{ filter: "grayscale(1)" }}
            >
              {b.name}
            </div>
          ))}
        </div>
      </div>

      <div className="marquee mt-8" style={{ animationDirection: "reverse" }}>
        <div className="marquee-track" style={{ animationDirection: "reverse", animationDuration: "60s" }}>
          {[...BRANDS].reverse().concat([...BRANDS].reverse()).map((b, i) => (
            <div
              key={i}
              className={`shrink-0 text-[#4A4D55] hover:text-accent transition-colors duration-500 ${b.style}`}
            >
              {b.name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogosMarquee;
